// WiFi Administrado - Ubiquiti Data (Enfocado en Telco/Reseller)
export const wifiHeroData = {
  tagline: "WIFI ADMINISTRADO",
  title: "Gestión centralizada de WiFi para Telcos y Resellers",
  subtitle: "Plataforma completa para administrar redes WiFi de tus clientes. Control de calidad de servicio, aprovisionamiento de SSIDs, gestión de usuarios y facturación integrada.",
  cta: "Comenzar ahora",
  secondaryCta: "Ver demo"
};

export const wifiFeaturesData = [
  {
    id: 1,
    title: "Gestión de QoS Centralizada",
    description: "Configura políticas de calidad de servicio por cliente, plan o tipo de tráfico desde un único panel de control.",
    icon: "Gauge"
  },
  {
    id: 2,
    title: "Aprovisionamiento de SSIDs",
    description: "Crea y despliega SSIDs personalizados por cliente con configuraciones predefinidas en segundos.",
    icon: "Wifi"
  },
  {
    id: 3,
    title: "Gestión de Usuarios",
    description: "Portal cautivo, autenticación RADIUS, límites de ancho de banda y control de acceso por usuario.",
    icon: "Users"
  },
  {
    id: 4,
    title: "Multi-Tenant",
    description: "Separa clientes, resellers y ubicaciones con permisos granulares y visibilidad independiente.",
    icon: "Building2"
  }
];

export const wifiCapabilitiesData = [
  {
    id: 1,
    title: "Políticas de Ancho de Banda",
    description: "Define límites de velocidad por plan, usuario o dispositivo con control en tiempo real.",
    icon: "Gauge"
  },
  {
    id: 2,
    title: "Portal Cautivo Personalizado",
    description: "Branding por cliente con autenticación social, vouchers o credenciales corporativas.",
    icon: "LayoutDashboard"
  },
  {
    id: 3,
    title: "Monitoreo de Experiencia",
    description: "Métricas de latencia, pérdida de paquetes y satisfacción del usuario en tiempo real.",
    icon: "Activity"
  },
  {
    id: 4,
    title: "Alertas Proactivas",
    description: "Notificaciones automáticas ante caídas, saturación o degradación del servicio.",
    icon: "Bell"
  },
  {
    id: 5,
    title: "Reportes por Cliente",
    description: "Dashboards y reportes automatizados de uso, dispositivos y rendimiento por cliente.",
    icon: "FileText"
  },
  {
    id: 6,
    title: "API de Integración",
    description: "Conecta con tu CRM, facturación y sistemas OSS/BSS mediante APIs REST.",
    icon: "Plug"
  }
];

export const wifiProductsData = [
  {
    id: 1,
    name: "Cloud Gateway Ultra",
    description: "Gateway compacto con WiFi 6 integrado, ideal para pequeñas y medianas empresas.",
    specs: ["WiFi 6", "1 Gbps", "IDS/IPS"],
    image: "https://cdn.ui.com/uploads/2023/09/Cloud-Gateway-Ultra-Top-Angle.png"
  },
  {
    id: 2,
    name: "UniFi Dream Machine Pro",
    description: "Gateway de alto rendimiento con grabación de video y protección avanzada.",
    specs: ["10G SFP+", "NVR integrado", "IDS/IPS"],
    image: "https://cdn.ui.com/uploads/2022/10/UDM-Pro.png"
  },
  {
    id: 3,
    name: "U7 Pro",
    description: "Access Point WiFi 7 de alto rendimiento con Multi-Link Operation.",
    specs: ["WiFi 7", "MLO", "2.5 GbE"],
    image: "https://cdn.ui.com/uploads/2024/01/U7-Pro.png"
  },
  {
    id: 4,
    name: "U6 Enterprise",
    description: "Access Point empresarial WiFi 6E con cobertura de largo alcance.",
    specs: ["WiFi 6E", "6 GHz", "2.5 GbE"],
    image: "https://cdn.ui.com/uploads/2023/03/U6-Enterprise.png"
  }
];

export const wifiStatsData = [
  { number: "300+", label: "Clientes por gateway" },
  { number: "QoS", label: "Gestión centralizada" },
  { number: "99.9%", label: "Uptime garantizado" },
  { number: "Multi-Tenant", label: "Arquitectura" }
];

// Starlink Management Data
export const starlinkHeroData = {
  tagline: "GESTIÓN STARLINK",
  title: "Opera tu negocio Starlink de extremo a extremo",
  subtitle: "Observabilidad en tiempo real, provisionamiento de clientes, gestión de bolsas y paquetes de datos, y control de consumos de toda tu flota Starlink desde una única plataforma.",
  cta: "Comenzar ahora",
  secondaryCta: "Ver demo"
};

export const starlinkFeaturesData = [
  {
    id: 1,
    title: "Observabilidad Total",
    description: "Telemetría en tiempo real de cada terminal: latencia, throughput, obstrucciones, uptime y alertas proactivas.",
    icon: "Activity"
  },
  {
    id: 2,
    title: "Provisionamiento de Clientes",
    description: "Da de alta clientes y activa service lines en minutos con flujos de aprovisionamiento automáticos y multi-tenant.",
    icon: "Users"
  },
  {
    id: 3,
    title: "Gestión de Bolsas de Datos",
    description: "Crea y administra bolsas de datos compartidas o por cliente, con recargas, vigencias y asignación flexible.",
    icon: "Database"
  },
  {
    id: 4,
    title: "Paquetes de Datos y Consumos",
    description: "Define paquetes con cuotas y precios, y controla el consumo por terminal, cliente o período con alertas automáticas.",
    icon: "BarChart3"
  }
];

export const starlinkCapabilitiesData = [
  {
    id: 1,
    title: "Gestión por Kit",
    description: "Administra cada terminal Starlink individualmente con historial de configuraciones y eventos.",
    icon: "Cpu"
  },
  {
    id: 2,
    title: "Aprovisionamiento Masivo",
    description: "Da de alta clientes y despliega configuraciones a múltiples terminales con templates predefinidos.",
    icon: "Layers"
  },
  {
    id: 3,
    title: "Bolsas y Recargas",
    description: "Administra bolsas de datos con recargas, vigencias y reasignación entre clientes o terminales.",
    icon: "Package"
  },
  {
    id: 4,
    title: "Control de Consumos",
    description: "Monitorea, limita y factura el consumo de datos por terminal, cliente, bolsa o período.",
    icon: "BarChart3"
  },
  {
    id: 5,
    title: "Geolocalización",
    description: "Visualiza la ubicación de todos los terminales en un mapa interactivo con filtros.",
    icon: "MapPin"
  },
  {
    id: 6,
    title: "Observabilidad y Alertas",
    description: "Dashboards de salud de flota y notificaciones proactivas ante obstrucciones, degradación o cortes de servicio.",
    icon: "Bell"
  }
];

export const starlinkStatsData = [
  { number: "1000+", label: "Terminales por cuenta" },
  { number: "24/7", label: "Observabilidad en tiempo real" },
  { number: "100%", label: "Control de bolsas y consumos" },
  { number: "API", label: "Integración completa" }
];

// FinOps - OptScale Data
export const finopsHeroData = {
  tagline: "FINOPS PLATFORM",
  title: "Optimización de costes cloud para tu negocio",
  subtitle: "Plataforma FinOps transversal para tus clientes y resellers. Visibilidad total, optimización automática y control de costes en AWS, Azure, GCP y Kubernetes.",
  cta: "Comenzar ahora",
  secondaryCta: "Ver demo"
};

export const finopsFeaturesData = [
  {
    id: 1,
    title: "Visibilidad Multi-Cloud",
    description: "Dashboard unificado para AWS, Azure, GCP y Kubernetes. Asigna costes por proyecto, equipo o servicio.",
    icon: "Eye"
  },
  {
    id: 2,
    title: "Optimización de Recursos",
    description: "Detección de recursos no utilizados, rightsizing automático y recomendaciones de instancias óptimas.",
    icon: "Gauge"
  },
  {
    id: 3,
    title: "Detección de Anomalías",
    description: "Alertas inteligentes ante picos inusuales de gasto con políticas personalizables.",
    icon: "AlertTriangle"
  },
  {
    id: 4,
    title: "Presupuestos y Cuotas",
    description: "Establece límites por proyecto o equipo con alertas y seguimiento en tiempo real.",
    icon: "Wallet"
  }
];

export const finopsCapabilitiesData = [
  {
    id: 1,
    title: "Reserved Instances & Savings Plans",
    description: "Gestión óptima de descuentos con recomendaciones automáticas de RI y Spot Instances.",
    icon: "Percent"
  },
  {
    id: 2,
    title: "Scheduling Automatizado",
    description: "Programa el encendido/apagado de VMs y clusters por equipo, proyecto y zona horaria.",
    icon: "Clock"
  },
  {
    id: 3,
    title: "Kubernetes Cost Analysis",
    description: "Rightsizing de CPU/memoria, escalado de nodos y análisis de costes por namespace.",
    icon: "Container"
  },
  {
    id: 4,
    title: "Mapas de Costes Geográficos",
    description: "Visualiza costes de egress y tráfico cross-region para optimizar la arquitectura.",
    icon: "Map"
  },
  {
    id: 5,
    title: "ML/AI Cost Tracking",
    description: "Monitoreo de costes de experimentos ML con integración MLFlow, TensorFlow y Spark.",
    icon: "Brain"
  },
  {
    id: 6,
    title: "S3 & Data Tools",
    description: "Detector de duplicados S3, instrumentación Redshift y soporte Databricks.",
    icon: "Database"
  }
];

export const finopsStatsData = [
  { number: "35%", label: "Ahorro promedio" },
  { number: "Multi-Cloud", label: "AWS, Azure, GCP" },
  { number: "K8s", label: "Soporte nativo" },
  { number: "Open Source", label: "Disponible en GitHub" }
];

export const finopsBenefitsData = [
  {
    id: 1,
    title: "Para tus Clientes",
    description: "Ofrece visibilidad de costes cloud como valor agregado. Dashboards personalizados y reportes automáticos.",
    features: ["Dashboards por cliente", "Reportes mensuales", "Alertas de presupuesto"]
  },
  {
    id: 2,
    title: "Para tus Resellers",
    description: "Permite que tus partners gestionen los costes de sus clientes con control granular.",
    features: ["Multi-tenancy", "Cuotas por proyecto", "Análisis comparativo"]
  },
  {
    id: 3,
    title: "Para tu Negocio",
    description: "Maximiza márgenes identificando oportunidades de optimización en toda tu base de clientes.",
    features: ["Visibilidad consolidada", "Benchmarking", "ROI tracking"]
  }
];

export const solutionLayersFAQData = [
  {
    question: "¿Cómo funciona la integración con Ubiquiti?",
    answer: "Nuestra plataforma se integra nativamente con UniFi Network Controller, permitiendo gestionar todos los dispositivos de tus clientes desde un único panel. Incluye aprovisionamiento automático, monitoreo y facturación integrada."
  },
  {
    question: "¿Qué proveedores cloud soporta FinOps?",
    answer: "Soportamos AWS, Microsoft Azure, Google Cloud Platform, Alibaba Cloud y cualquier entorno Kubernetes. La integración es automática mediante APIs y permite visibilidad unificada multi-cloud."
  },
  {
    question: "¿Puedo ofrecer FinOps como servicio a mis clientes?",
    answer: "Sí, la plataforma es multi-tenant, lo que te permite crear dashboards personalizados para cada cliente o reseller con sus propios presupuestos, alertas y reportes."
  },
  {
    question: "¿Cómo se gestiona la flota de Starlink?",
    answer: "La plataforma ofrece observabilidad en tiempo real de cada terminal, provisionamiento de clientes y service lines, gestión de bolsas y paquetes de datos, y control de consumos con alertas automáticas. Incluye APIs para integración con tus sistemas de facturación y CRM."
  },
  {
    question: "¿Es necesario hardware específico para WiFi administrado?",
    answer: "Recomendamos equipos Ubiquiti UniFi por su compatibilidad nativa, pero la plataforma puede integrarse con otros fabricantes mediante APIs estándar."
  }
];
